var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.ambassador.image,"alt":""}}),_c('br'),_vm._v("\n   "+_vm._s(_vm.ambassador.fname)+" "+_vm._s(_vm.ambassador.lname.charAt(0))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }